export function getTypes(types, report, offerName) {
    if (!offerName) {
        let result = [];
        Object.keys(report).forEach((item) => {
            result = result.concat(types.filter((type) => type.offer.offer_name === item.slice(1)));
        });
        return result;
    }
    else {
        return types.filter((type) => type.offer.offer_name === offerName);
    }
}
